// extracted by mini-css-extract-plugin
export var defaultWidth = "Slider-module--defaultWidth--45505";
export var mediumWidth = "Slider-module--mediumWidth--5696d";
export var smallWidth = "Slider-module--smallWidth--849e0";
export var hidden = "Slider-module--hidden--23c24";